import type { components } from '@fluencelabs/vodopad-admin-api'
import { Alert, Card, Space, Table } from 'antd'

import { ClusterNameLink } from '@/components/common/ClusterNameLink'
import { formatUsdCents } from '@/utils/money'

import { capacityColumns, ipColumns } from './capacityColumns'
import { computeIpRows, computeRows } from './capacitySummary'
import { MeasuredAt } from './MeasuredAt'

type Cluster = components['schemas']['ClusterCapacityDto']

export function ClusterCapacityCard({
  cluster,
  chargedCents,
  chargedLabel,
}: {
  cluster: Cluster
  /** Whose charges and over which period. */
  chargedLabel: string
  /** Undefined while charges are loading or failed to load. */
  chargedCents?: number
}) {
  const collected = cluster.inventory?.hardwareCollectedAt
  return (
    <Card
      title={
        cluster.removedAt ? (
          cluster.name
        ) : (
          <ClusterNameLink clusterId={cluster.clusterId} />
        )
      }
      style={{ marginTop: 16 }}
    >
      <Space size="large" wrap style={{ marginBottom: 16 }}>
        <span>
          {chargedLabel}:{' '}
          {chargedCents === undefined ? '—' : formatUsdCents(chargedCents)}
        </span>
        {collected && <MeasuredAt at={collected} prefix="Measured" />}
      </Space>
      {cluster.removedAt && (
        <Alert
          type="info"
          showIcon
          message="Cluster removed: hardware is no longer measured, recorded VMs are shown"
        />
      )}
      {!cluster.inventory && !cluster.removedAt && (
        <Alert type="warning" showIcon message="Hardware not measured yet" />
      )}
      <Table
        size="small"
        scroll={{ x: 1180 }}
        dataSource={computeRows(cluster)}
        rowKey="resource"
        pagination={false}
        columns={capacityColumns}
      />
      {cluster.inventory?.publicIps && (
        <Table
          size="small"
          scroll={{ x: 780 }}
          style={{ marginTop: 16 }}
          dataSource={computeIpRows(cluster)}
          rowKey="family"
          pagination={false}
          columns={ipColumns}
        />
      )}
    </Card>
  )
}
